import { render, staticRenderFns } from "./card-producto-pedido2.vue?vue&type=template&id=5526d73c&scoped=true"
import script from "./card-producto-pedido2.vue?vue&type=script&lang=js"
export * from "./card-producto-pedido2.vue?vue&type=script&lang=js"
import style0 from "./card-producto-pedido2.vue?vue&type=style&index=0&id=5526d73c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5526d73c",
  null
  
)

export default component.exports